/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Gc_Search_Guides_What_Is_Gridcraft_Sections_4_Steps_2Inputs */

const en_gc_search_guides_what_is_gridcraft_sections_4_steps_2 = /** @type {(inputs: Gc_Search_Guides_What_Is_Gridcraft_Sections_4_Steps_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Make the edit, inspect the result and save a new workbook. Reopen that saved file to confirm that the change was retained.`)
};

const zh_gc_search_guides_what_is_gridcraft_sections_4_steps_2 = /** @type {(inputs: Gc_Search_Guides_What_Is_Gridcraft_Sections_4_Steps_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`修改输入、检查结果并保存新工作簿。重新打开保存的文件，确认修改得以保留。`)
};

/**
* | output |
* | --- |
* | "Make the edit, inspect the result and save a new workbook. Reopen that saved file to confirm that the change was retained." |
*
* @param {Gc_Search_Guides_What_Is_Gridcraft_Sections_4_Steps_2Inputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const gc_search_guides_what_is_gridcraft_sections_4_steps_2 = /** @type {((inputs?: Gc_Search_Guides_What_Is_Gridcraft_Sections_4_Steps_2Inputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Gc_Search_Guides_What_Is_Gridcraft_Sections_4_Steps_2Inputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_gc_search_guides_what_is_gridcraft_sections_4_steps_2(inputs)
	return zh_gc_search_guides_what_is_gridcraft_sections_4_steps_2(inputs)
});
export { gc_search_guides_what_is_gridcraft_sections_4_steps_2 as "gc.search_guides.what_is_gridcraft.sections.4.steps.2" }